
import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

const Terms = () => {
  return (
    <div className="min-h-screen flex flex-col bg-white font-montserrat">
      <Header />
      <main className="flex-grow container mx-auto px-4 py-8 max-w-4xl">
        <h1 className="font-playfair text-3xl font-bold text-crimson mb-6">Terms of Service</h1>
        <div className="prose max-w-none">
          <section className="mb-8">
            <h2 className="font-playfair text-xl text-gray-800 mb-4">1. Introduction</h2>
            <p className="mb-4">
              Welcome to Alumni Insights! These Terms of Service ("Terms") govern your access to and use of the Alumni Insights website, services, and applications (collectively, the "Service").
            </p>
            <p className="mb-4">
              By accessing or using our Service, you agree to be bound by these Terms. If you disagree with any part of the Terms, you may not access the Service.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-playfair text-xl text-gray-800 mb-4">2. Accounts and Registration</h2>
            <p className="mb-4">
              When you create an account with us, you must provide accurate, complete, and current information. Failure to do so constitutes a breach of the Terms, which may result in immediate termination of your account.
            </p>
            <p className="mb-4">
              You are responsible for safeguarding the password that you use to access the Service and for any activities or actions under your password.
            </p>
            <p className="mb-4">
              You agree not to disclose your password to any third party. You must notify us immediately upon becoming aware of any breach of security or unauthorized use of your account.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-playfair text-xl text-gray-800 mb-4">3. User Content</h2>
            <p className="mb-4">
              Our Service allows you to post, link, store, share and otherwise make available certain information, text, graphics, videos, or other material ("Content").
            </p>
            <p className="mb-4">
              You are responsible for the Content that you post to the Service, including its legality, reliability, and appropriateness.
            </p>
            <p className="mb-4">
              By posting Content to the Service, you grant us the right and license to use, modify, publicly perform, publicly display, reproduce, and distribute such Content on and through the Service.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-playfair text-xl text-gray-800 mb-4">4. Service Booking and Payments</h2>
            <p className="mb-4">
              Alumni who offer services through our platform are responsible for the quality and delivery of their services.
            </p>
            <p className="mb-4">
              Students booking services agree to pay the specified fees and attend scheduled sessions. Cancellation policies may apply as specified by individual alumni.
            </p>
            <p className="mb-4">
              Alumni Insights takes a service fee from each transaction, details of which are provided during the booking process.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-playfair text-xl text-gray-800 mb-4">5. Termination</h2>
            <p className="mb-4">
              We may terminate or suspend your account immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.
            </p>
            <p className="mb-4">
              Upon termination, your right to use the Service will immediately cease. If you wish to terminate your account, you may simply discontinue using the Service.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-playfair text-xl text-gray-800 mb-4">6. Changes to Terms</h2>
            <p className="mb-4">
              We reserve the right, at our sole discretion, to modify or replace these Terms at any time. We will try to provide at least 30 days' notice prior to any new terms taking effect.
            </p>
            <p className="mb-4">
              By continuing to access or use our Service after those revisions become effective, you agree to be bound by the revised terms.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-playfair text-xl text-gray-800 mb-4">7. Contact Us</h2>
            <p className="mb-4">
              If you have any questions about these Terms, please contact us at support@alumniinsights.com.
            </p>
          </section>

          <div className="mt-12 text-sm text-gray-600">
            <p>Last updated: April 7, 2025</p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Terms;
